<template>
  <v-drawer :direction="'right'" :width="'26%'">
    <!-- 底部箭头 -->
    <bar-card :bg="'border10'">
      <div style="height:35%">
        <c-title :item="obj"> </c-title>
        <div class="sqjcBox boxs">
          <img class="sqjcBg" :src="sqjcBg" alt="" />
          <div v-if="list.length > 0">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="sqjcDataMsg sqjcData"
              :class="'sqjcData' + (index + 1)"
            >
              <p v-for="(it, i) in item" :key="i">
                {{ splitStrFunc(it.name) }}
                <span v-if="it.name"
                  >：{{ it.value
                  }}<span v-show="it.value !== '数据异常'">{{ it.unit }}</span>
                </span>
              </p>
              <div :class="(index + 1) % 2 == 0 ? 'deep-txt-two' : 'deep-txt'">
                {{ item[0].subgroup_code }}
              </div>
            </div>
          </div>

          <div class="otherBox" v-if="list2.length > 0">
            <p v-for="(item, i) in list2" :key="i">
              {{ item.name }}
              <span>：{{ item.value }}{{ item.unit }}</span>
            </p>
          </div>
        </div>
      </div>
      <div style="height:37%;position: relative;">
        <div class="homeTitle">
          <img
            style="margin-right: 0.05rem;width: 20px;"
            src="~images/zhwl/ls.png"
          />
          历史数据
        </div>
        <div class="boxs">
          <el-tabs v-model="time" @tab-click="handleClick">
            <el-tab-pane label="今天" name="1"></el-tab-pane>
            <el-tab-pane label="最近三天" name="3"></el-tab-pane>
            <el-tab-pane label="最近一周" name="7"></el-tab-pane>
            <el-tab-pane label="近15天" name="15"></el-tab-pane>
            <el-tab-pane label="近30天" name="30"></el-tab-pane>
          </el-tabs>
          <div class="selectBtn" v-if="select.length > 0">
            <div
              :class="
                selectOn == index ? 'selectBtnList selectOn' : 'selectBtnList'
              "
              v-for="(item, index) in select"
              :key="index"
              @click="selectClick(index)"
            >
              <!-- <img :src="item.img" alt="" /> -->
              <span>{{ item.name }}</span>
            </div>
          </div>
          <div class="chart" ref="chart"></div>
        </div>
      </div>
      <div style="height:28%">
        <div class="homeTitle">
          <img
            style="margin-right: 0.05rem;"
            src="~images/components/vtitleh.png"
          />
          农情图片
        </div>
        <div class="pic-cont">
          <swiper
            :options="swiperOptionjk"
            class="imgcasesT"
            v-if="swiperList.length > 0"
          >
            <swiper-slide
              v-for="(it, i) in swiperList"
              :key="i"
              class="swiper-slides"
            >
              <div class="swiper-item">
                <div class="pic-cont-left">
                  <img :src="it.image_path" class="img-jc" />
                  <!-- ai识别红框 -->
                  <div class="recognise">
                    <div
                      class="signDiv"
                      v-for="(its, index) in it.signList"
                      :key="index"
                      :style="{
                        left: its.location.left * w_ratio + 'px',
                        top: its.location.top * h_ratio + 'px',
                        width: its.location.width * w_ratio + 'px',
                        height: its.location.height * h_ratio + 'px',
                      }"
                    ></div>
                  </div>
                </div>

                <div class="pic-cont-right">
                  <div class="cont-right-item">
                    <div class="pic-cont-name">成熟度：</div>
                    <div class="cont-progress">{{ it.growthPhase }}</div>
                  </div>
                  <div
                    class="cont-right-item"
                    v-for="(item, index) in it.signList"
                    :key="index"
                  >
                    <div class="pic-cont-name">置信度：</div>
                    <div class="cont-progress">
                      {{ handleConf(item.location.score) }}
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <!-- Add Arrows -->
          <div
            v-if="swiperList.length > 0"
            class="swiper-button-next swiper-button-next2"
            slot="button-next"
          ></div>
          <div
            v-if="swiperList.length > 0"
            class="swiper-button-prev swiper-button-prev2"
            slot="button-prev"
          ></div>
          <div class="empty-tip" v-if="swiperList.length < 1">暂无图片</div>
        </div>
      </div>
    </bar-card>
  </v-drawer>
</template>

<script>
import cTitle from "../components/title";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
// import { findWlwSoidByPlaceId } from "@/api/zhnc";
import {
  findQxzWlwnNwestData,
  getCallRemoteHistoryData,
  getWlwInfoImageSbGroupByDayAndWlwCode,
} from "@/api/zhwl";
import { loadSqChart } from "./chart/sqData";
import { mapGetters } from "vuex";
export default {
  components: {
    Swiper,
    SwiperSlide,
    cTitle,
  },
  data() {
    return {
      obj: {
        src: require("images/zhwl/sq.png"),
        name: "墒情监测",
        hasBtn: true,
        left: true,
      },
      sqjcBg: require("images/zhwl/sqjcBg.png"),
      time: "1",
      select: [
        {
          name: "温度",
          img: "",
        },
        {
          name: "湿度",
          img: "",
        },
        {
          name: "土壤电导率",
        },
        {
          name: "太阳总辐射",
        },
        {
          name: "土壤pH",
        },
      ],
      selectOn: 0,
      list: [],
      list2: [],
      endTime: this.$formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
      startTime: this.$formatDate(
        new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000),
        "yyyy-MM-dd hh:mm:ss"
      ),
      swiperOptionjk: {
        autoplay: true,
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        spaceBetween: 8,
        loop: true, // 循环轮播
        navigation: {
          nextEl: ".swiper-button-next2",
          prevEl: ".swiper-button-prev2",
        },
        speed: 300,
      },
      swiperList: [],
      w_ratio: 1,
      h_ratio: 1,
    };
  },

  created() {},
  mounted() {
    this.dataLoad();
    this.chart = this.$echarts.init(this.$refs.chart);
    window.addEventListener("resize", () => {
      this.chart.resize();
    });
    this.loadChart();
  },
  computed: {
    ...mapGetters(["baseMsg", "graphic"]),
  },
  watch: {
    baseMsg(val) {
      this.dataLoad(val.id);
    },
    graphic() {
      this.clearChart();
      this.dataLoad();
      this.time = "1";
      this.loadChart();
    },
  },
  methods: {
    dataLoad() {
      this.obj.name = this.graphic.name;
      this.getNqPicData(this.graphic.code);
      findQxzWlwnNwestData({
        deviceId: this.graphic.code,
      }).then((res) => {
        console.log("res", res);
        let data = res.data.data;
        let newArr = [];
        let newArr2 = [];
        data.map((item) => {
          item.value =
            Number(item.value) < -1999 && item.unit == "℃"
              ? "数据异常"
              : item.value;
          item.value =
            Number(item.value) < 0 && item.unit == "%"
              ? "数据异常"
              : item.value;
          if (item.name.indexOf("cm") > -1) {
            newArr.push(item);
          } else {
            newArr2.push(item);
          }
        });
        var a = newArr;
        this.list = [];
        for (let i = 0; i < a.length; i += 2) {
          this.list.push(a.slice(i, i + 2));
        }
        console.log("this.list", this.list);

        this.list2 = newArr2;
        console.log("this.list2", this.list2);
        // let a = data;
        // for (var i = 0; i < a.length / 2; i++) {
        //   if (a[i * 2 + 1]) {
        //     this.list.push([a[i * 2], a[i * 2 + 1]]);
        //   } else {
        //     this.list.push([a[i * 2], []]);
        //   }
        // }
      });
    },
    splitStrFunc(str) {
      if (str) {
        return str.split("cm")[1];
      }
    },
    loadChart() {
      getCallRemoteHistoryData({
        deviceNo: this.graphic.code,
        startTime: this.startTime,
        endTime: this.endTime,
        orderTime: "asc",
      }).then((res) => {
        if (res.code === 200) {
          let data = [];
          let unit = "";
          let type = "";
          let istoday = false;
          if (this.selectOn === 0) {
            istoday = true;
            type = "3";
            for (var i = 0; i < res.data.data.length; i++) {
              data.push({
                date: res.data.data[i].time,
                value10: res.data.data[i].wsenValue1,
                value20: res.data.data[i].wsenValue2,
                value30: res.data.data[i].wsenValue3,
              });
            }
            unit = "℃";
          } else if (this.selectOn === 1) {
            type = "3";
            for (i = 0; i < res.data.data.length; i++) {
              data.push({
                date: res.data.data[i].time,
                value10: res.data.data[i].wsenValue4,
                value20: res.data.data[i].wsenValue5,
                value30: res.data.data[i].wsenValue6,
              });
            }
            unit = "%";
          } else if (this.selectOn === 2) {
            for (i = 0; i < res.data.data.length; i++) {
              data.push({
                date: res.data.data[i].time,
                value10: res.data.data[i].wsenValue7,
              });
            }
            unit = "µS/cm";
          } else if (this.selectOn === 3) {
            for (i = 0; i < res.data.data.length; i++) {
              data.push({
                date: res.data.data[i].time,
                value10: res.data.data[i].wsenValue8,
              });
            }
            unit = "W/m2";
          } else if (this.selectOn === 4) {
            for (i = 0; i < res.data.data.length; i++) {
              data.push({
                date: res.data.data[i].time,
                value10: res.data.data[i].wsenValue9,
              });
            }
            unit = "";
          }
          loadSqChart(this.chart, data, unit, type, istoday);
        }
      });
    },
    handleClick(val) {
      const day = Number(val.name);
      this.startTime = this.$formatDate(
        new Date(new Date().getTime() - day * 24 * 60 * 60 * 1000),
        "yyyy-MM-dd hh:mm:ss"
      );
      this.loadChart();
    },
    selectClick(index) {
      this.selectOn = index;
      this.loadChart();
    },
    clearChart() {
      this.chart.clear();
    },
    getNqPicData(code) {
      this.swiperList = [];
      getWlwInfoImageSbGroupByDayAndWlwCode({
        wlwCode: code,
        // wlwCode: "CJ02A-2110027",
        size: 10,
      }).then((res) => {
        let data = res.data;
        data.map((item) => {
          item.signList = [];
          // 兼容处理
          item.signList = JSON.parse(item.location.replace(/'/g, '"'))
            ? JSON.parse(item.location.replace(/'/g, '"')).data
            : [];
          item.image_path = window.__config.VUE_APP_IMG_URL + item.url;
          this.swiperList.push(item);
        });
        this.addImg(res);
      });
    },
    //识别生成图片
    addImg(params) {
      params;
      this.w_ratio = document.querySelector(".pic-cont").offsetWidth / 2560;
      this.h_ratio = document.querySelector(".pic-cont").offsetHeight / 1440;
    },
    handleConf(score) {
      console.log(score, "-----score");
      if (score) {
        let str = (score * 100).toFixed(2) + "%";
        return str;
      }
    },
  },
};
</script>
<style>
.rightBg {
  background: rgba(21, 41, 66, 0.8);
}
.homeTitle {
  padding: 12px;
  color: #80e4fb;
  padding-bottom: 5px;
  letter-spacing: 1px;
  font-size: 16px;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
}
.boxs {
  padding: 4px 12px;
  height: calc(100% - 0.25rem);
}

.topArrow::after {
  content: "";
  border-top: solid 4px #80e4fb;
  border-left: solid 4px #80e4fb;
  padding: 0.05208rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.topArrow::before {
  content: "";
  border-top: solid 4px #80e4fb;
  border-right: solid 4px #80e4fb;
  padding: 0.05208rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

.buttomArrow::after {
  content: "";
  border-bottom: solid 4px #80e4fb;
  border-left: solid 4px #80e4fb;
  padding: 0.05208rem;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.buttomArrow::before {
  content: "";
  border-bottom: solid 4px #80e4fb;
  border-right: solid 4px #80e4fb;
  padding: 0.05208rem;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
}
</style>
<style lang="stylus" scoped>
.sqjcBg
  height 100%
  display block
  margin 0 auto
  position absolute
  top 0
  left 50%
  transform translate(-50%, 0)

.sqjcBox
  width 100%
  height calc(100% - 40px)
  position relative

.sqjcData
  position absolute

.sqjcDataMsg
  width 35%

.sqjcDataMsg p
  line-height 1.5
  color rgb(3, 228, 227)

.sqjcDataMsg p:first-child
  border-bottom:2px solid rgb(3, 228, 227)

.sqjcDataMsg span
  color #fff

.sqjcDataNum p
  color #fff

.sqjcData1
  top 20%
  right 50%
  transform translate(-8px, -50%)

.sqjcData2
  top 40%
  left 50%
  transform translate(10px, -50%)
  text-align right

.sqjcData3
  top 80%
  right 50%
  transform translate(-8px, -50%)

.sqjcData4
  top 20%
  left 50%
  transform translate(20px, -50%)

.sqjcData5
  top 40%
  right 50%
  transform translate(-20px, -50%)

.sqjcData6
  top 80%
  left 50%
  transform translate(20px, -50%)

.otherBox
  position absolute
  top 1%
  right 6%
  p
    line-height 1.5
    color #03e4e3
    span
      color #fff

.chart
  height calc(100% - 0.3rem)
  width 100%

/deep/.el-tabs__item
  color #fff

/deep/.el-tabs__item.is-active
  color rgb(243, 208, 19)

/deep/.el-tabs__nav-wrap::after
  height 0

/deep/.el-tabs__active-bar
  background rgb(243, 208, 19)

.selectBtn
  position absolute
  top 90px
  right 10px
  display flex
  flex-wrap wrap
  justify-content center
  z-index 1

.selectBtnList
  padding 3px
  cursor pointer

.selectBtnList span
  color #fff

.selectOn span
  color rgb(14, 156, 255) !important

.deep-txt
  position absolute
  top 22%
  right -30%
  color #fff
.deep-txt-two
  position absolute
  left -30%
  top 22%
  color #fff
.pic-cont
  width 100%
  height calc(100% - 60px)
  position relative
  // display flex
  // justify-content space-between
  padding 0 20px
  overflow-y hidden
  box-sizing border-box
  color #fff
.pic-cont-left
  width calc(70% - 30px)
  height 100%
  position relative
.img-jc
  width 100%
  height 100%
  object-fit cover
  border-radius 3px
.pic-cont-right
  width 30%
  height 100%
  display flex
  align-items center
  flex-wrap wrap
.cont-right-item
  width 100%
  display flex
  align-items center
  font-size 13px
  .pic-cont-name
    margin-right 20px
.swiper-item
  width 100%
  height 100%
  display flex
  justify-content space-between
.swiper-button-prev2
    background url('~images/index/szjc/left.png') center no-repeat
    background-size 100% 100%
    margin-top -22px
.swiper-button-next2
    background url('~images/index/szjc/right.png') center no-repeat
    background-size 100% 100%
    margin-top -22px
.swiper-button-prev:after, .swiper-button-next:after
    display none
.imgcasesT
    margin 0 10px
    height 100%
.el-carousel
  height 100%

  >>>.el-carousel__mask
    background rgba(0, 0, 0, 0)

  >>>.el-carousel--horizontal
    overflow hidden

  >>>.el-carousel__container
    height 100%

.recognise
  position absolute
  width 100%
  height 100%
  background-color transparent
  z-index 14
  top 0
  img
    width 100%
    height 100%
.signDiv
  position absolute
  border 1px solid #ff0000
.empty-tip
  width 100px
  height 40px
  line-height 40px
  font-size 16px
  text-align center
  color #80e4fb
  border solid 1px #80e4fb
  border-radius 0.03125rem
  margin 20% auto
</style>
